export default __webpack_public_path__ + "static/media/ed1.8fa18e2f.png";